import * as React from 'react'
import {
  getLocalStorageItem,
  setLocalStorageItem
} from '../../../common/utils/localStorageHelpers'
import ThemeforestEaseOfUseSurvey from '../../components/banners/themeforestEaseOfUseSurvey'
import Experiment from '../../components/experiment'
import Variant from '../../components/experiment/variant'

interface IProps {
  location: any
  currentSite: string
}

const RenderSurvey = (props: IProps) => {
  const { location, currentSite } = props

  const cache = {
    get: (cacheKey: string) => getLocalStorageItem(cacheKey),
    set: (cacheKey: string, variantId: number) =>
      setLocalStorageItem(cacheKey, variantId)
  }

  if (props.currentSite === 'themeforest') {
    return (
      <Experiment
        id="XHbr8E-VSVeHER8HvTH5gQ"
        location={location}
        cache={cache}
        defaultVariantId={0}
        forcedVariantId={
          location.query.variant && parseInt(location.query.variant, 10)
        }
      >
        <Variant variantId={0}>
          <ThemeforestEaseOfUseSurvey
            currentSite={currentSite}
            surveyUrl="https://www.surveymonkey.com/r/55YD5HT"
          />
        </Variant>
        <Variant variantId={1}>
          <ThemeforestEaseOfUseSurvey
            currentSite={currentSite}
            surveyUrl="https://www.surveymonkey.com/r/55YD5HT"
          />
        </Variant>
        <Variant variantId={2}>
          <ThemeforestEaseOfUseSurvey
            currentSite={currentSite}
            surveyUrl="https://www.surveymonkey.com/r/NBSBSC7"
          />
        </Variant>
        <Variant variantId={3}>
          <ThemeforestEaseOfUseSurvey
            currentSite={currentSite}
            surveyUrl="https://www.surveymonkey.com/r/NBSBSC7"
          />
        </Variant>
        <Variant variantId={4}>
          <ThemeforestEaseOfUseSurvey
            currentSite={currentSite}
            surveyUrl="https://www.surveymonkey.com/r/NBNMN7Z"
          />
        </Variant>
        <Variant variantId={5}>
          <ThemeforestEaseOfUseSurvey
            currentSite={currentSite}
            surveyUrl="https://www.surveymonkey.com/r/NBNMN7Z"
          />
        </Variant>
      </Experiment>
    )
  } else {
    return null
  }
}

export default RenderSurvey



// WEBPACK FOOTER //
// ./client/pages/search/renderSurvey.tsx